import { defineComponent } from 'vue';
export default defineComponent({
  name: 'ExamHunanInfo',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
});